<template>
    <card class="responsive-card-table">
    <div
        v-if="!loading"	
    > 
        <div
        v-if="revisions.length === 0">
        <h2 class="text-center">Nessuna revisione da inviare</h2>
        </div>
        <im-table 
        v-else
        :loading="loading"
        :model="revisions"
        :url="buildUrl"
        :layout="''"
        :delete-column="false"
        @getAll="search">
        <template slot="columns">
            <el-table-column
            label="Data">
            <template slot-scope="scope">
                {{scope.row.revisionDate | moment('DD/MM/YYYY')}}
            </template>
            </el-table-column>
            <el-table-column
            label="Cliente">
            <template slot-scope="scope">
                <router-link 
                class="text-info"
                :to="`/sites/${scope.row.engine.site._id}`">
                {{scope.row.engine.site.clientName}}
                </router-link>
            </template>
            </el-table-column>
            <el-table-column
            label="Cantiere">
            <template slot-scope="scope">
                <router-link 
                class="text-info"
                :to="`/sites/${scope.row.engine.site._id}`">
                {{scope.row.engine.site.name}}
                </router-link>
            </template>
            </el-table-column>
            <el-table-column
            label="Motore">
            <template slot-scope="scope">
                <router-link 
                class="text-info"
                :to="`/sites/${scope.row.engine.site._id}/engines/${scope.row.engine._id}`">
                {{scope.row.engine.name}} ({{scope.row.engine.registrationNumber}})
                </router-link>
            </template>
            </el-table-column>
            <el-table-column
            prop="finalRevision.number"
            label="N. REPORT">
            </el-table-column>
            <el-table-column
            label="Segna come conclusa">
            <template slot-scope="scope">
                  <div class="btn btn-info" @click="checkAsClosed(scope)">
                    <i class="tim-icons icon-check-2"></i>
                  </div>
            </template>
            </el-table-column>
        </template>
        </im-table>
    </div>
    </card>
</template>
<script>
    import swal from 'sweetalert2';

    import { Table, TableColumn, Pagination } from 'element-ui'
    import { mapState, mapActions } from 'vuex'
    export default {
        name: 'revisions-dashboard-list',
        components: {
            [TableColumn.name] : TableColumn
        },
        computed: {
            ...mapState({
            revisions: state => state.revisions.revisionsDashboard,
            loading: state => state.revisions.loading,
            }),
        },
        data() {
            return {
                lastParams: {}
            }
        },
        methods: {
            ...mapActions('revisions', {
                getRevisions: 'getAllDashboard',
                deleteRevision: 'delete',
                updateRevision: 'update' 
            }),
            search(params) {
                let query = {
                    ...this.lastParams,
                    ...params,
                    deleted: false,
                    isClosed: false
                }
                this.getRevisions(query)
                console.log("MH")
                this.lastParams = query
            },
            buildUrl(scope) {
                return `/engines/${scope.row.engine._id}/revisions/${scope.row.id}`
            },
            async checkAsClosed(scope) {
            const confirm = await swal.fire({
                title: 'Stai per segnare questa revisione come "conclusa?"',
                // text: "You won't be able to revert this!",
                type: 'danger',
                confirmButtonText: 'Confermo',
                showCancelButton: true,
                cancelButtonText: 'Annulla',
                reverseButtons: true
            })

            if (confirm.value) {
                await this.updateRevision({
                    id: scope.row.id,
                    engine: scope.row.engine._id,
                    isClosed: true
                })
                this.search()
            }
            },
            deleteRequest(scope) {
                this.deleteRevision({
                    engineId: scope.row.engine._id,
                    id: scope.row.id,
                })
            },
        },
        mounted(params) {
            this.search(params)
        },
    }
</script>